import axios from "axios";
import { validateClinicBranchParams } from "@/utils/routeValidation";

const moduleDiscount = {
  namespaced: true,
  state: {
    discountList: [],
    suggestedDiscounts: {},
  },
  mutations: {
    setDiscountList(state, data) {
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch {
          data = [];
        }
      }
      state.discountList = Array.isArray(data) ? data : [];
    },
    setSuggestedDiscounts(state, data) {
      state.suggestedDiscounts = data || {};
    },
  },
  getters: {
    getDiscountList: state => state.discountList,
    getSuggestedDiscounts: state => state.suggestedDiscounts,
  },
  actions: {
    fetchDiscountList({ commit }, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "fetchDiscountList")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .get(`/api/discount/${payload.clinicUrl}/${payload.branchUrl}`)
        .then(res => {
          commit("setDiscountList", res.data);
          return res;
        });
    },

    fetchDiscountByID(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "fetchDiscountByID")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .get(`/api/discount/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`)
        .then(res => res.data);
    },

    createDiscount(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "createDiscount")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .post(`/api/discount/${payload.clinicUrl}/${payload.branchUrl}`, payload.data)
        .then(res => res.data);
    },

    updateDiscount(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "updateDiscount")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .put(`/api/discount/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`, payload.data)
        .then(res => res.data);
    },

    deleteDiscount(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "deleteDiscount")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .delete(`/api/discount/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`)
        .then(res => res.data);
    },

    suggestDiscounts({ commit }, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "suggestDiscounts")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .post(`/api/discount/${payload.clinicUrl}/${payload.branchUrl}/suggest`, {
          treatmentItems: payload.treatmentItems,
        })
        .then(res => {
          commit("setSuggestedDiscounts", res.data);
          return res.data;
        });
    },
  },
};

export default moduleDiscount;
